module.exports = __webpack_public_path__ + "static/nginx-f51e7d54d4c06a7553cc579f8ce5eabe.png";